import { getSupplierAvatar } from './Supplier'
import { countUniqueStatii } from './StatiiCounts'
import type { IOrderOverview, IOrderServiceOrder } from '~/types/order/models'
import type { TSiloOverview } from '~/types/silo/models'
import {
  isIOpportunityOverviewData,
  isIOrderOverviewData,
} from '~/types/silo/models'

const mn = `[cynqueModules/dataObjects/OrderServiceOrder.ts]`

export function OrderServiceOrder(o: IOrderServiceOrder): IOrderServiceOrder {
  const fn = `${mn} OrderServiceOrder |`
  if (!o) {
    throw new Error(
      `${fn} OrderServiceOrder called with falsey orderServiceOrder`
    )
  }
  if (!o.order) {
    throw new Error(`${fn} OrderServiceOrder called with falsey order`)
  }
  if (!o.supplier) {
    throw new Error(`${fn} OrderServiceOrder called with falsey supplier`)
  }

  const obj = { ...o }

  // orderServiceOrder.supplier is an ISelectItem
  const supplierOrderNum = obj.supplierOrderNum
    ? `#${obj.supplierOrderNum}`
    : 'No Supplier O/N'
  obj.label = `${obj.hrid} | ${obj.supplier.label} | ${supplierOrderNum} | ${obj.descr}`

  obj.tenantAndSupplierPMsDescr = `${
    obj.tenantProductionManager?.person?.label ?? '---'
  }\n${obj.supplierProductionManager?.person?.label ?? '---'}`

  obj.supplier.avatar = getSupplierAvatar(obj.supplier.label)

  obj.supplierAndSupplierOrderNumDescr =
    obj.supplier.label + '\n' + obj.supplierOrderNum

  // Aging

  if (obj.createdAt) {
    const today = new Date()
    const created = new Date(obj.createdAt)
    const msBetween = today.getTime() - created.getTime()
    obj.numDaysSinceCreation = Math.round(msBetween / (1000 * 60 * 60 * 24))
  }

  console.debug(`${fn} returning`, obj)
  return obj
}

export function propagateOrderServiceOrderData({
  callingFn,
  overviewData,
}: {
  callingFn: string
  overviewData: TSiloOverview
}) {
  const fn = `${callingFn} --> ${mn} propagateOrderServiceOrderData |`
  console.debug(`${fn}`)
  if (isIOpportunityOverviewData(overviewData)) {
    throw new Error(
      `propagateOrderServiceOrderData called with an OpportunityOverview.`
    )
  } else if (isIOrderOverviewData(overviewData)) {
    propagateOrderServiceOrderDataToOrder({
      overviewData,
    })
  } else {
    console.error(
      `${fn} NOT AN OPPORTUNITY-OVERVIEW OR AN ` +
        ` ORDER-OVERVIEW. THERE IS A PROBLEM!!!!`
    )
  }
}

function propagateOrderServiceOrderDataToOrder({
  overviewData,
}: {
  overviewData: IOrderOverview
}) {
  const fn = `${mn} propagateOrderServiceOrderDataToOrder |`
  const order = overviewData.order
  const orderServiceOrders = overviewData.orderServiceOrders
  console.debug(
    `${fn} propagating based on ${orderServiceOrders?.length ?? 0}` +
      ` orderServiceOrders`
  )
  // DEBUG AID — uncomment to snapshot the service orders as they are on entry,
  // before the status counts below overwrite what the cards read. Same reasoning
  // as the snapshot in OrderMSService.ts: the clone is what makes the log show
  // this moment rather than the final state.
  //
  // Needs `import { cloneDeep } from 'lodash'` restored at the top of the file.
  //
  // console.debug(
  //   `${fn} propagating based on this orderServiceOrder info...`,
  //   cloneDeep(orderServiceOrders)
  // )
  order.numOrderServiceOrders = orderServiceOrders?.length ?? 0
  const counts = countUniqueStatii(orderServiceOrders)
  console.debug(`${fn} counts =`, counts)
  order.orderServiceOrderStatusCounts = counts
}
